interface IYoutubeLinkParams {
  videoId: string;
  timestampInSec?: number;
}

export function parseYoutubeLink(url: string): IYoutubeLinkParams | null {
  const match = url?.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([-\w]+)([?&]\S+)?/);

  if (!match) return null;

  const [_, videoId, queryParams] = match;

  return {
    videoId,
    timestampInSec: queryParams ? parseTimestamp(queryParams) : undefined,
  };
}

function parseTimestamp(queryParams: string): number | undefined {
  const searchParams = new URLSearchParams(queryParams);
  const timestamp = searchParams.get('t');

  if (!timestamp) return undefined;

  const ONLY_DIGITS = /^\d+$/;
  if (ONLY_DIGITS.test(timestamp)) {
    return parseInt(timestamp);
  }

  const DURATION_REGEX = /(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/i; //eg. 1h2m3s
  const match = timestamp.match(DURATION_REGEX);
  if (!match || match[0].length === 0) return undefined;

  const [_, hours, minutes, seconds] = match;
  const parseOrZero = (value: string | undefined) => (value ? parseInt(value) : 0);

  return parseOrZero(hours) * 3600 + parseOrZero(minutes) * 60 + parseOrZero(seconds);
}
